import type { SceneContent } from '../../presentation/types';
import { ecosystemPhases } from '../../components/ecosystemMap';

export const future: SceneContent = {
  id: 'future',
  shortLabel: 'GROWING',
  title: 'A Growing Ecosystem',
  seconds: 35,
  brand: 'moderta',
  bridgeIn: 'Which brings us back to the whole picture.',
  atmosphere: (step) => ({ pattern: step === 1 ? 'inward' : 'orbit', density: step >= 2 ? 0.4 : 0.24, opacity: 0.07, cameraZ: step >= 2 ? 17 : 15 }),
  script: (context) => {
    const mint = context.isEnabled('mint');
    const hasSelected = ecosystemPhases(context).some((phase) => phase[0].tier === 'selected');
    return {
      title: 'A Growing Ecosystem',
      onScreen: ['A GROWING ECOSYSTEM.', 'BUILT AROUND PROBLEMS WORTH SOLVING.'],
      visual: `The ecosystem comes back together in order: ${mint ? 'MINT with its branches first, then ' : ''}the other products${hasSelected ? ', with selected work last and quietest' : ''}. Pulses run inward along every spoke to Moderta and the core glows. The view pulls back to show unnamed, softly glowing nodes on an outer ring. The inner orbit lights.`,
      narration: [
        mint ? 'Put it all back together. MINT at the centre of it, with its specialisations, and the products around it.' : 'Put it all back together.',
        'These systems are different, but the approach behind them is the same: understand the problem, connect the information, build the right system, and let it evolve. Every line leads back to that.',
        'And there is deliberately room around it. This is a growing ecosystem.',
        'Built around problems worth solving.',
      ],
      presenterNotes: [
        'The ecosystem reassembles. Let the order speak; do not list products again.',
        'Pulses flow back to Moderta. "The approach behind them is the same."',
        'The view pulls back; unnamed nodes appear. "A growing ecosystem." Do not name future products.',
        '"Built around problems worth solving."',
      ],
    };
  },
};
